module.exports = __webpack_public_path__ + "img/hw.56c4f4fb.jpg";